import mod from "-!./settings.js?vue&type=script&lang=js&"; export default mod; export * from "-!./settings.js?vue&type=script&lang=js&"